import { render, staticRenderFns } from "./PartnerOrderCheckoutTerms.vue?vue&type=template&id=25b4ac3a&scoped=true"
import script from "./PartnerOrderCheckoutTerms.vue?vue&type=script&lang=js"
export * from "./PartnerOrderCheckoutTerms.vue?vue&type=script&lang=js"
import style0 from "./PartnerOrderCheckoutTerms.vue?vue&type=style&index=0&id=25b4ac3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b4ac3a",
  null
  
)

export default component.exports